type IsDefaultAddressType = 'true' | 'false' | null | undefined;

export const checkIsDefaultAddress = (
  isDefaultAddress: IsDefaultAddressType,
) => {
  if (isDefaultAddress === 'false') return false;
  if (isDefaultAddress === 'true') return true;
  return isDefaultAddress;
};
